<template>
    <footer class="text-white text-center bg-black/50 py-4 mt-4">
        <div class="grid grid-flow-col text-sm mb-4">
            <div class="col-span-1" v-for="(status, name) in server_status">
                {{ name }} <span v-if="status" class="text-green-600"><i class="fa-duotone fa-circle-check"></i></span>
                <span v-else class="text-red-800"><i class="fa-duotone fa-circle-xmark"></i></span>
            </div>
        </div>
        <div class="my-2 grid grid-cols-2 gap-6 flex justify-center items-center">
            <div>
                Lonvel {{ $page.props.version }} developed by <a href="https://scarm.dev/">Cappuccino</a>
            </div>
            <div>
                <Link preserve-scroll class="pr-3.5" :href="route('ban_list')">{{ $t("Ban list") }}</Link>
                <a v-for="link in links" class="pr-3.5" :href="link.link">{{ link.name }}</a>
            </div>
        </div>
    </footer>
</template>

<script setup>
import {Link, usePage} from '@inertiajs/inertia-vue3'
import {computed} from "vue";

let links = computed(() => usePage().props.value.nav.footer)
let server_status = computed(() => usePage().props.value.stats.server_status)
</script>
